import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useGetColumns } from '../hooks/useGetColumns';
import { useGetRows } from '../hooks/useGetRows';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { downloadExcel } from '../../../utils/downloadExcel';
import { formatCurrency } from '../../../utils/mathUtils';
import moment from 'moment';

export const BuscarPacienteDetalleContent = ({ setChildrenAction }) => {
    const params = useParams();

    const idPaciente = parseInt(params.idPaciente);

    const {
        rows,
        loading,
        totalCount,
        handleSearch
    } = useGetRows(idPaciente);

    const columns = useGetColumns();

    useEffect(() => {
        handleSearch();
    }, []);


    // const exportExcel = useCallback(() => {
    //     const processedRows = rows.map(row => ({
    //         ...row,
    //         fechaDesde: moment(row.fechaDesde).year() < 1500 ? '-' : moment(row.fechaDesde).format('DD/MM/YYYY'),
    //         fechaHasta: moment(row.fechaHasta).year() < 1500 ? '-' : moment(row.fechaHasta).format('DD/MM/YYYY'),
    //         fechaDesdeSuspension: moment(row.fechaDesdeSuspension).year() < 1500 ? '-' : moment(row.fechaDesdeSuspension).format('DD/MM/YYYY'),
    //         fechaHastaSuspension: moment(row.fechaHastaSuspension).year() < 1500 ? '-' : moment(row.fechaHastaSuspension).format('DD/MM/YYYY'),
    //         precioDiario: row.precioDiario ? formatCurrency(row.precioDiario) : ''
    //     }));

    //     const processedColumns = columns.map(column => ({
    //         headerName: column.headerName,
    //         field: column.field
    //     }));

    //     downloadExcel({
    //         fileName: `Contratos_Paciente_HC_${idPaciente}`,
    //         sheet: "Contratos",
    //         tablePayload: {
    //             header: processedColumns,
    //             body: processedRows
    //         }
    //     });
    // }, [rows, idPaciente]);

    // Queda obsoleto
    // useEffect(() => {
    //     setChildrenAction(() => {
    //         return (
    //             <CustomButton
    //                 label='Exportar'
    //                 onClick={exportExcel}
    //                 variant='contained'
    //                 disabled={loading || totalCount === 0}
    //             >
    //                 Exportar
    //             </CustomButton>
    //         )
    //     }
    //     );
    // }, [exportExcel]);

    return (
        <div>
            <DataGridGenerico
                columns={columns}
                rows={rows}
                totalCount={totalCount}
                loading={loading}
                toolbar={false}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'contrato', sort: 'desc' }],
                    },
                }}
            />
        </div>
    );
}
